import axios from "axios";

const setupAxiosInterceptors = (Keycloak) => {
  const onRequestSuccess = (config) => {
    if (Keycloak && Keycloak.authenticated) {
      try {
        Keycloak.updateToken(70)
            .then((refreshed) => {
              if (refreshed) {
                console.debug("Token refreshed" + refreshed);
              }
            })
            .catch((err) => {
              console.log(err);
            // logoutFunction(Keycloak, Cookies);
            });
        const keyclockToken = Keycloak.token || "";
        config.headers.Authorization = `Bearer ${keyclockToken}`;
      } catch (err) {
        console.log(err);
      }
    }
    return config;
  };
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error && error.message) {
          return Promise.reject(error);
        }
      },
  );
};

export default setupAxiosInterceptors;

